import { atom } from "jotai";

export const hideHistoricalFindingsAtom = atom<boolean>(false);
